export const STORAGE_KEY = 'polotno-uploaded-images';
export const IMAGE_ACCEPT = '.jpg,.jpeg,.png,image/jpeg,image/png';
export const DESIGN_IMPORT_ACCEPT =
	'.json,.svg,.pdf,.ai,application/json,image/svg+xml,application/pdf';

export const IMAGE_ALLOWED_MIME_TYPES = [
	'image/jpeg',
	'image/jpg',
	'image/png',
];

export const IMAGE_ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png'];

export const MAX_IMAGE_FILE_SIZE = 15000000;
export const MAX_IMAGE_FILE_SIZE_LABEL = 15;
export const MAX_VIDEO_TEMPLATE_COVERAGE = 0.6;
export const IMPORT_ASSET_LOAD_TIMEOUT_MS = 120000;
export const IMPORT_LOG_SUPPRESSION_MAX_MS = 120000;
export const DEFAULT_AUDIO_THUMBNAIL = 'https://s3.us-west-1.wasabisys.com/bay/smc/soundwave.png';

export const REPLACEABLE_IMAGE_ELEMENT_TYPES = ['image', 'gif'];

export const ALLOWED_IMAGE_TYPES = {
	'image/*': ['.png', '.jpg', '.jpeg', '.gif'],
};

export const ALLOWED_VIDEO_TYPES = {
	'video/*': ['.mp4', '.mov'],
};

export const ALLOWED_AUDIO_TYPES = {
	'audio/*': ['.mp3', '.wav'],
};
